module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('ExtForm', {
    attrs: {
      "formData": _vm.formData,
      "submitProxy": _vm.submitProxy,
      "loadProxy": _vm.loadProxy,
      "submitBtnText": "Сохранить изменения"
    }
  }, [_c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('name')
    },
    attrs: {
      "label": "Имя",
      "feedback": _vm.errors.first('name')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('letters_only'),
      expression: "'letters_only'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('surname')
    },
    attrs: {
      "label": "Фамилия",
      "feedback": _vm.errors.first('surname')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('letters_only'),
      expression: "'letters_only'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.surname),
      expression: "formData.surname"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "surname"
    },
    domProps: {
      "value": (_vm.formData.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.surname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('patronymic')
    },
    attrs: {
      "label": "Отчество",
      "feedback": _vm.errors.first('patronymic')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('letters_only'),
      expression: "'letters_only'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.patronymic),
      expression: "formData.patronymic"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "patronymic"
    },
    domProps: {
      "value": (_vm.formData.patronymic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.patronymic = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('birthdate')
    },
    attrs: {
      "label": "Дата рождения",
      "feedback": _vm.errors.first('birthdate')
    }
  }, [_c('InlineDatepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date'),
      expression: "'required|date'"
    }],
    attrs: {
      "name": "birthdate"
    },
    model: {
      value: (_vm.formData.birthdate),
      callback: function($$v) {
        _vm.formData.birthdate = $$v
      },
      expression: "formData.birthdate"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('email')
    },
    attrs: {
      "label": "Email",
      "feedback": _vm.errors.first('email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.formData.email),
      expression: "formData.email",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email"
    },
    domProps: {
      "value": (_vm.formData.email)
    },
    on: {
      "change": function($event) {
        _vm.formData.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('tel')
    },
    attrs: {
      "label": "Контактный телефон",
      "feedback": _vm.errors.first('tel')
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('+7 (###) ###-##-##'),
      expression: "'+7 (###) ###-##-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.tel),
      expression: "formData.tel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tel"
    },
    domProps: {
      "value": (_vm.formData.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.tel = $event.target.value
      }
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13f2c505"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/PersonalData.vue
// module id = 219
// module chunks = 1